import React, { useEffect, useState } from 'react';
import InvoiceBadge from './InvoiceBadge';
import Pagination from '@mui/material/Pagination';

interface IInvoices {
  invoices: any;
}

const Invoices: React.FC<IInvoices> = ({ invoices }) => {
  const [ page, setPage ] = useState(0);
  const [ pageCount, setPageCount ] = useState<number>(1);
  const [ paginatedInvoices, setPaginatedInvoices ] = useState([ [] ]);

  const handlePageChange = (e: any, new_page: number) => {
    const handledPage = new_page - 1;
    setPage(handledPage);
  };

  const convertAmount = (amount: any) => {
    const total = amount / 100;
    return total.toFixed(2);
  };

  const convertTimestamp = (time: any) => {
    let date: any = new Date(time * 1000);
    date = `${date.getMonth() + 1 }/${ date.getDate() }/${ date.getFullYear()}`;
    return date;
  };

  const splitArrayIntoChunks = (array: any, chunkSize: number) => {
    const result: any = [];
    if (array) {
      for (let i = 0; i < array.length; i = i + chunkSize) {
        result.push(array.slice(i, i + chunkSize));
      }
      setPageCount(result.length);
      setPaginatedInvoices(result);
    }
  };

  useEffect(() => {
    splitArrayIntoChunks(invoices.data, 5);
  }, [ invoices ]);


  if (paginatedInvoices.length === 0) {
    return (
      <div className='invoices-container'>
        <div className='invoices-none-text'>
          No Invoices Available
        </div>
      </div>
    );
  }

  return (
    <div className='invoices-container'>
      <div className='billing-history-header'>
        <div className='billing-history-text-group'>
          <div className='billing-history-primary-text'>
            Invoices
          </div>
        </div>
      </div>
      <div className='invoices-content'>
        <div className='invoice-table-column-first'>
          <div className='invoice-column-header'>
            <div className='invoice-column-header-spacing'>
              <div className='invoice-column-header-text'>
                Invoice
              </div>
            </div>
          </div>
          {paginatedInvoices[page].map((invoice: any, index: number) => (
            <div key={index} className='invoice-column-body-cell'>
              <svg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40' fill='none'>
                <path d='M7.75 4C7.75 2.20508 9.20508 0.75 11 0.75H27C27.1212 0.75 27.2375 0.798159 27.3232 0.883885L38.1161 11.6768C38.2018 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4Z' stroke='#4A4C51' strokeWidth='1.5'/>
                <path d='M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5' stroke='#4A4C51' strokeWidth='1.5'/>
                <path d='M1 20C1 18.8954 1.89543 18 3 18H25C26.1046 18 27 18.8954 27 20V32C27 33.1046 26.1046 34 25 34H3C1.89543 34 1 33.1046 1 32V20Z' fill='#D92D20'/>
                <path d='M4.8323 30V22.7273H7.70162C8.25323 22.7273 8.72316 22.8326 9.11142 23.0433C9.49967 23.2517 9.7956 23.5417 9.9992 23.9134C10.2052 24.2827 10.3082 24.7088 10.3082 25.1918C10.3082 25.6747 10.204 26.1009 9.99565 26.4702C9.78732 26.8395 9.48547 27.1271 9.09011 27.3331C8.69712 27.5391 8.22127 27.642 7.66255 27.642H5.83372V26.4098H7.41397C7.7099 26.4098 7.95375 26.3589 8.14551 26.2571C8.33964 26.1529 8.48405 26.0097 8.57875 25.8274C8.67581 25.6428 8.72434 25.4309 8.72434 25.1918C8.72434 24.9503 8.67581 24.7396 8.57875 24.5597C8.48405 24.3774 8.33964 24.2365 8.14551 24.1371C7.95138 24.0353 7.70517 23.9844 7.40687 23.9844H6.36994V30H4.8323ZM13.885 30H11.3069V22.7273H13.9063C14.6379 22.7273 15.2676 22.8729 15.7955 23.1641C16.3235 23.4529 16.7295 23.8684 17.0136 24.4105C17.3 24.9527 17.4433 25.6013 17.4433 26.3565C17.4433 27.1141 17.3 27.7652 17.0136 28.3097C16.7295 28.8542 16.3211 29.272 15.7884 29.5632C15.2581 29.8544 14.6237 30 13.885 30ZM12.8445 28.6825H13.8211C14.2757 28.6825 14.658 28.602 14.9681 28.4411C15.2806 28.2777 15.515 28.0256 15.6713 27.6847C15.8299 27.3414 15.9092 26.8987 15.9092 26.3565C15.9092 25.8191 15.8299 25.38 15.6713 25.0391C15.515 24.6982 15.2818 24.4472 14.9717 24.2862C14.6615 24.1252 14.2792 24.0447 13.8247 24.0447H12.8445V28.6825ZM18.5823 30V22.7273H23.3976V23.995H20.1199V25.728H23.078V26.9957H20.1199V30H18.5823Z' fill='white'/>
              </svg>
              <div className='invoice-column-body-text'>
                Invoice #{invoice.number}
              </div>
            </div>
          ))}
        </div>
        <div className='invoice-table-column'>
          <div className='invoice-column-header'>
            <div className='invoice-column-header-spacing'>
              <div className='invoice-column-header-text'>
                Billing Date
              </div>
            </div>
          </div>
          {paginatedInvoices[page].map((invoice: any, index: number) => (
            <div key={index} className='invoice-column-body-cell'>
              <div className='invoice-column-body-text'>
                {convertTimestamp(invoice.created)}
              </div>
            </div>
          ))}
        </div>
        <div className='invoice-table-column'>
          <div className='invoice-column-header'>
            <div className='invoice-column-header-spacing'>
              <div className='invoice-column-header-text'>
                Amount
              </div>
            </div>
          </div>
          {paginatedInvoices[page].map((invoice: any, index: number) => (
            <div key={index} className='invoice-column-body-cell'>
              <div className='invoice-column-body-text'>
                {invoice.currency.toUpperCase()} ${convertAmount(invoice.amount_due)}
              </div>
            </div>
          ))}
        </div>
        <div className='invoice-table-column'>
          <div style={{ borderRadius: '0px 8px 0px 0px' }} className='invoice-column-header'>
            <div className='invoice-column-header-spacing'>
              <div className='invoice-column-header-text'>
                Status
              </div>
            </div>
          </div>
          {paginatedInvoices[page].map((invoice: any, index: number) => (
            <div key={index} className='invoice-column-body-cell'>
              {invoice.status === 'paid' && (
                <InvoiceBadge
                  border='2px solid #38E09A'
                  background='rgba(56, 224, 154, 0.15)'
                  icon={<svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' fill='none'>
                    <path d='M11.0833 1.75H2.91667C2.275 1.75 1.75 2.275 1.75 2.91667V11.0833C1.75 11.725 2.275 12.25 2.91667 12.25H11.0833C11.725 12.25 12.25 11.725 12.25 11.0833V2.91667C12.25 2.275 11.725 1.75 11.0833 1.75ZM6.2475 9.5025C6.02 9.73 5.6525 9.73 5.425 9.5025L3.33083 7.40833C3.10333 7.18083 3.10333 6.81333 3.33083 6.58583C3.55833 6.35833 3.92583 6.35833 4.15333 6.58583L5.83333 8.26583L9.84667 4.2525C10.0742 4.025 10.4417 4.025 10.6692 4.2525C10.8967 4.48 10.8967 4.8475 10.6692 5.075L6.2475 9.5025Z' fill='#26B670'/>
                  </svg>}
                  text='Paid'
                />
              )}
              {invoice.status === 'open' && (
                <InvoiceBadge
                  border='2px solid var(--Warning-400, #FDB022)'
                  background='rgba(253, 176, 34, 0.15)'
                  icon={<svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' fill='none'>
                    <path d='M7.00027 9.33366C6.88489 9.33366 6.77211 9.36787 6.67618 9.43196C6.58026 9.49606 6.50549 9.58717 6.46134 9.69376C6.41719 9.80035 6.40563 9.91764 6.42814 10.0308C6.45065 10.1439 6.50621 10.2479 6.58779 10.3295C6.66937 10.411 6.77331 10.4666 6.88646 10.4891C6.99962 10.5116 7.11691 10.5001 7.2235 10.4559C7.33009 10.4118 7.42119 10.337 7.48529 10.2411C7.54939 10.1451 7.5836 10.0324 7.5836 9.91699C7.5836 9.76228 7.52214 9.6139 7.41274 9.50451C7.30335 9.39511 7.15498 9.33366 7.00027 9.33366ZM13.2244 10.1912L8.5286 2.02449C8.37682 1.75237 8.15514 1.52571 7.88646 1.36793C7.61778 1.21014 7.31185 1.12695 7.00027 1.12695C6.68868 1.12695 6.38275 1.21014 6.11407 1.36793C5.84539 1.52571 5.62371 1.75237 5.47193 2.02449L0.805266 10.1912C0.64823 10.456 0.563849 10.7576 0.560642 11.0655C0.557435 11.3733 0.635515 11.6766 0.786999 11.9447C0.938484 12.2127 1.15801 12.4361 1.42341 12.5922C1.68882 12.7483 1.99071 12.8316 2.2986 12.8337H11.7019C12.0123 12.8367 12.3179 12.7572 12.5874 12.6032C12.8569 12.4492 13.0806 12.2263 13.2355 11.9574C13.3905 11.6884 13.4711 11.3831 13.4691 11.0728C13.4672 10.7624 13.3827 10.4581 13.2244 10.1912ZM12.2153 11.3578C12.1641 11.4488 12.0895 11.5244 11.9992 11.5767C11.909 11.629 11.8063 11.6562 11.7019 11.6553H2.2986C2.19425 11.6562 2.09157 11.629 2.00128 11.5767C1.911 11.5244 1.8364 11.4488 1.78527 11.3578C1.73407 11.2691 1.70711 11.1686 1.70711 11.0662C1.70711 10.9638 1.73407 10.8632 1.78527 10.7745L6.45193 2.60782C6.50089 2.51227 6.57526 2.43208 6.66686 2.37609C6.75846 2.32009 6.86374 2.29046 6.9711 2.29046C7.07846 2.29046 7.18374 2.32009 7.27534 2.37609C7.36694 2.43208 7.44131 2.51227 7.49027 2.60782L12.1861 10.7745C12.244 10.8619 12.2772 10.9633 12.2824 11.068C12.2875 11.1727 12.2643 11.2768 12.2153 11.3695V11.3578ZM7.00027 4.66699C6.84556 4.66699 6.69718 4.72845 6.58779 4.83784C6.47839 4.94724 6.41693 5.09561 6.41693 5.25032V7.58365C6.41693 7.73836 6.47839 7.88674 6.58779 7.99613C6.69718 8.10553 6.84556 8.16699 7.00027 8.16699C7.15498 8.16699 7.30335 8.10553 7.41274 7.99613C7.52214 7.88674 7.5836 7.73836 7.5836 7.58365V5.25032C7.5836 5.09561 7.52214 4.94724 7.41274 4.83784C7.30335 4.72845 7.15498 4.66699 7.00027 4.66699Z' fill='#FDB022'/>
                  </svg>}
                  text='Pending'
                />
              )}
              {invoice.status === 'uncollectible' && (
                <InvoiceBadge
                  border='2px solid var(--Error-500, #F04438)'
                  background='rgba(240, 68, 56, 0.15)'
                  icon={<svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' fill='none'>
                    <path d='M7.00033 4.08366C6.84562 4.08366 6.69725 4.14512 6.58785 4.25451C6.47845 4.36391 6.41699 4.51228 6.41699 4.66699V7.00033C6.41699 7.15504 6.47845 7.30341 6.58785 7.4128C6.69725 7.5222 6.84562 7.58366 7.00033 7.58366C7.15504 7.58366 7.30341 7.5222 7.41281 7.4128C7.5222 7.30341 7.58366 7.15504 7.58366 7.00033V4.66699C7.58366 4.51228 7.5222 4.36391 7.41281 4.25451C7.30341 4.14512 7.15504 4.08366 7.00033 4.08366ZM7.53699 9.11199C7.52423 9.07482 7.50657 9.03951 7.48449 9.00699L7.41449 8.91949C7.33246 8.83855 7.2283 8.78372 7.11514 8.76192C7.00198 8.74012 6.88489 8.75232 6.77866 8.79699C6.70797 8.82653 6.64286 8.86797 6.58616 8.91949C6.5321 8.974 6.48932 9.03864 6.4603 9.10971C6.43127 9.18079 6.41655 9.25689 6.41699 9.33366C6.41792 9.40989 6.43377 9.4852 6.46366 9.55532C6.48986 9.62771 6.53166 9.69346 6.58609 9.74789C6.64053 9.80233 6.70627 9.84413 6.77866 9.87033C6.84849 9.90119 6.92399 9.91713 7.00033 9.91713C7.07667 9.91713 7.15217 9.90119 7.22199 9.87033C7.29438 9.84413 7.36013 9.80233 7.41456 9.74789C7.469 9.69346 7.5108 9.62771 7.53699 9.55532C7.56689 9.4852 7.58274 9.40989 7.58366 9.33366C7.58652 9.29482 7.58652 9.25583 7.58366 9.21699C7.57362 9.17979 7.55788 9.14437 7.53699 9.11199ZM7.00033 1.16699C5.8466 1.16699 4.71879 1.50911 3.7595 2.15009C2.80021 2.79106 2.05254 3.7021 1.61103 4.76801C1.16952 5.83391 1.054 7.0068 1.27908 8.13835C1.50416 9.26991 2.05973 10.3093 2.87554 11.1251C3.69134 11.9409 4.73075 12.4965 5.8623 12.7216C6.99386 12.9467 8.16675 12.8311 9.23265 12.3896C10.2986 11.9481 11.2096 11.2004 11.8506 10.2412C12.4915 9.28187 12.8337 8.15405 12.8337 7.00033C12.8337 6.23428 12.6828 5.47574 12.3896 4.76801C12.0965 4.06027 11.6668 3.41721 11.1251 2.87554C10.5834 2.33386 9.94038 1.90418 9.23265 1.61103C8.52492 1.31788 7.76637 1.16699 7.00033 1.16699ZM7.00033 11.667C6.07735 11.667 5.1751 11.3933 4.40767 10.8805C3.64024 10.3677 3.0421 9.6389 2.68889 8.78618C2.33568 7.93346 2.24327 6.99515 2.42333 6.0899C2.60339 5.18466 3.04785 4.35314 3.7005 3.70049C4.35314 3.04785 5.18466 2.60339 6.08991 2.42333C6.99515 2.24326 7.93346 2.33568 8.78618 2.68889C9.63891 3.0421 10.3677 3.64023 10.8805 4.40766C11.3933 5.17509 11.667 6.07735 11.667 7.00033C11.667 8.238 11.1753 9.42499 10.3002 10.3002C9.42499 11.1753 8.23801 11.667 7.00033 11.667Z' fill='#F04438'/>
                  </svg>}
                  text='Unpaid'
                />
              )}
            </div>
          ))}
        </div>
        <div className='invoice-table-column'>
          <div className='invoice-column-header'>
            <div className='invoice-column-header-spacing'>
              <div className='invoice-column-header-text'></div>
            </div>
          </div>
          {paginatedInvoices[page].map((invoice: any, index: number) => (
            <>
              {invoice.hosted_invoice_url !== null && (
                <div key={index} className='invoice-column-body-cell'>
                  <div className='invoice-column-body-text'>
                    <a className='invoice-column-body-text-view' href={`${invoice.hosted_invoice_url}`} target='_blank' rel='noreferrer'>
                      View
                    </a>
                  </div>
                </div>
              )}
            </>
          ))}
        </div>
      </div>
      <div className='screening-results-footer'>
        <div className='screening-results-pagination-text'>
            Page {page + 1} of {pageCount}
        </div>
        <div className='screening-results-footer-action-group'>
          <div className='hb-pagination'>
            <Pagination
              onChange={handlePageChange}
              size='large'
              count={pageCount}
              shape='rounded'
              variant='text'
              page={page + 1}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Invoices;
